module.exports = __webpack_public_path__ + "img/desc_bottom_blznc03.753fc5ab.png";